var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6608 13.0516L16 23.6034L25 13.0516H19.6608Z",
    fill: "#FFE182"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7241 8.39661L7 13.0518H12.3392L10.7241 8.39661Z",
    fill: "#FFCD73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6607 13.0518H24.9999L21.2758 8.39661L19.6607 13.0518Z",
    fill: "#FFCD73"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6609 13.0518L16.0001 8.39661L12.3393 13.0518H19.6609Z",
    fill: "#FFCD73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 8.39661H10.7239L12.339 13.0518L15.9997 8.39661Z",
    fill: "#FFAA64"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2759 8.39661H16L19.6608 13.0518L21.2759 8.39661Z",
    fill: "#FFE182"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3393 13.0516L16.0001 23.6034L19.6609 13.0516H12.3393Z",
    fill: "#FFAA64"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.0516L16 23.6034L12.3392 13.0516H7Z",
    fill: "#FF8C5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.542d941d.svg";
export { ForwardRef as ReactComponent };